import { render, staticRenderFns } from "./fk.vue?vue&type=template&id=3fdf626e&"
import script from "./fk.vue?vue&type=script&lang=js&"
export * from "./fk.vue?vue&type=script&lang=js&"
import style0 from "./fk.vue?vue&type=style&index=0&id=3fdf626e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports